import { render, staticRenderFns } from "./UcInvoicePartyPanel.yaml?vue&type=template&id=689ad912&component"
import script from "./UcInvoicePartyPanel.yaml?vue&type=script&lang=ts&component"
export * from "./UcInvoicePartyPanel.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports